<script lang="ts">

    export let title = "";

    export let expanded = false;//TODO: set to false after development!


    function toggleDropdown(e: Event) {
        console.log("toggle");
        e.preventDefault();
        e.stopPropagation();
        expanded = !expanded;
    }

    /*
    $: {

        if(expanded){

            expanded = false;
        }else{
            console.log("toggle expanded from false to true")
            expanded = true;
        }

    }
*/


</script>

<!-- toggle if you click anywhere in the whole component
<svelte:window on:click={() => expanded = false}/>
-->

<div class="accordion-wrapper">
    <span class="accordion-el w-100" class:expanded={expanded}>
        <div class="accordion-title" on:click={toggleDropdown}>{title}</div>
        <div class="accordion-content">
            <slot name="content"></slot>
        </div>
    </span>
</div>
<style lang="scss">

  .accordion-wrapper{
    margin: 0;
    padding: 0;
    position: relative;
    width: 100%;
    height: 100%;
    min-height:3rem;
  }

  .accordion-wrapper *{

    margin:0;

  }
    .accordion-el {
     // margin-top: 5px;
      border-radius:10px;
      width: 97%;
      position: absolute;
      display: inline-block;
      /*font-size: x-large;*/
      font-weight: normal;
      min-height: 3em;
      max-height: 2em;
      overflow: hidden;
      //top: 0.5em;
      cursor: pointer;
      text-align: left;
      white-space: nowrap;
      color: #000000;
      outline: none;
      background-color: #FFFFFF;
      transition: 0.3s all ease-in-out;
      z-index: 99;
      //background-color:lightgreen;
      padding:10px;
      padding-right: 2rem;
      padding-left: 2rem;
    }

    .accordion-el input:focus + label {
      background: #def;
    }

    .accordion-el input {
      width: 1px;
      height: 1px;
      display: inline-block;
      position: absolute;
      opacity: 0.01;
    }

    .accordion-el label {
      display: block;
      height: 2.5em;
      line-height: 2em;
      padding-left: 1em;
      padding-right: 3em;
      cursor: pointer;
      position: relative;
      transition: 0.3s color ease-in-out;

    }

    .accordion-el label:nth-child(2) {
      margin-top: 2em;
    }

    .accordion-el input:checked + label {
      display: block;
      border-top: none;
      position: absolute;
      top: 0;
      width: 100%;
    }

    .accordion-el input:checked + label:nth-child(2) {
      margin-top: 0;
      position: relative;

    }

    .accordion-el::after {
     // content: "";
      position: absolute;
      right: 0.8em;
      top: 0;
      line-height:3rem;
    //  border: 0.3em solid #777777;
     // border-color: #777777 transparent transparent transparent;
     content: url("data:image/svg+xml,%3Csvg width='13' height='8' viewBox='0 0 13 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.81322 7.72701L0.286495 2.46079C-0.095499 2.09681 -0.0954989 1.50823 0.286496 1.14811L1.20491 0.272991C1.5869 -0.0909968 2.2046 -0.0909967 2.58253 0.272992L6.5 4.00581L10.4175 0.272993C10.7995 -0.0909952 11.4172 -0.0909951 11.7951 0.272993L12.7135 1.14811C13.0955 1.5121 13.0955 2.10068 12.7135 2.4608L7.18678 7.72701C6.81291 8.091 6.19522 8.091 5.81322 7.72701Z' fill='%23054055'/%3E%3C/svg%3E");
      transform: rotate(90deg);
      transition: 0.4s all ease-in-out;
    }

    .accordion-el.expanded {
      //padding: 0;
      //box-shadow: rgba(0, 0, 0, 0.1) 3px 3px 5px 0;
      box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
     // min-height: 15em;
      height:auto;
      min-height:3em;
      max-height:1000em;
      overflow:visible;

    }

    .accordion-el.expanded label:hover {
      color: #3694d7;
    }

    .accordion-el.expanded input:checked + label {
      color: #3694d7;
    }

    .accordion-el.expanded::after {
      transform-origin: center;
      transform: rotate(180deg);
      //top: 0.55em;

    }

    .accordion-title{
      height: 32px;
      font-size:20px;
      font-weight:700;
      width: 100%;
      position: absolute;
      z-index:1;
    }
    .accordion-content{
      margin-top:40px;
      white-space: pre-wrap;
    }

    .accordion-content.show{

    }

</style>
